<script setup lang="ts">
import { useClock } from '#src/composables/useClock'

const {
  locale = 'en-GB',
  interval = 5_000
} = defineProps<{
  locale?: string
  interval?: number
}>()

const { date, time } = useClock({ locale, interval })
</script>

<template>
  <div class="nxg-retail-clock" data-cy="timeAndDate">
    <div class="nxg-retail-clock__time" data-cy="time">{{ time }}</div>
    <div class="nxg-retail-clock__date" data-cy="date">{{ date }}</div>
  </div>
</template>

<style scoped>
.nxg-retail-clock {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  height: 56px;
  padding: 0 var(--nxgds-alias-spacing-md);
  color: var(--nxgds-mapped-color-text-primary);
  white-space: nowrap;
  text-align: center;
  background: var(--nxgds-mapped-color-surface-component-subsection);
  border-radius: var(--nxgds-alias-radius-corner-theme);
}

.nxg-retail-clock__time {
  font-family: var(--nxgds-alias-type-desktop-h4-strong-font-family);
  font-size: var(--nxgds-alias-type-desktop-h4-strong-size);
  font-weight: var(--nxgds-alias-type-desktop-h4-strong-weight);
  line-height: var(--nxgds-alias-type-desktop-h4-strong-line-height);
  letter-spacing: var(--nxgds-alias-type-desktop-h4-strong-letter-spacing);
}

.nxg-retail-clock__date {
  color: var(--nxgds-mapped-color-text-secondary);
  font-family: var(--nxgds-alias-type-desktop-label-big-regular-font-family);
  font-size: var(--nxgds-alias-type-desktop-label-regular-size);
  font-weight: var(--nxgds-alias-type-desktop-label-regular-weight);
  line-height: var(--nxgds-alias-type-desktop-label-regular-line-height);
  letter-spacing: var(--nxgds-alias-type-desktop-label-regular-letter-spacing);
}
</style>
